<div class="display-block">
  <button
    class="btnsize"
    type="button" pButton
    pTooltip="{{'Bsk_List' | translate}}"
    icon="pi icons8-bo-te-de-r-ception" styleClass="p-button-success"
    (click)="visibleListBsk = true"
  ></button>
  {{'Basket' | translate}} {{ currentBasket }}
  @if (currentfilterName !== '') {
    <span>, {{'Filter_Act' | translate}} : {{ currentfilterName }} </span>
  }
  @if (index == 1) {
    <div class="right">
      @if (displayListResult === false) {
        <i
          [ngClass]="currentfilterName !== '' ? 'pi-filter-fill' : 'pi-filter'"
          class="pi margin iconsize cursorPointer"
          pTooltip="{{'Filter_Res' | translate}}"
          tooltipPosition="left"
          (click)="onFilterBasket()"
        ></i>
        @if (allowFullText===true) {
          <button
            class="btnsize margin-left"
            type="button" pButton
            pTooltip={{filterState.message}}
            tooltipPosition="left"
            [ngClass]="filterState.state === true ? 'p-button-warning' : 'p-button-primary'"
            icon="pi icons8-search"
            (click)="onFilterSearch()"
          ></button>
        }
      }@else {
        <button
          class="btnsize margin-left"
          type="button" pButton
          pTooltip="{{'Return_Res' | translate}}"
          tooltipPosition="left"
          icon="pi icons8-retour" styleClass="p-button-success"
          (click)="returnList()"
        ></button>
      }
    </div>
  }
</div>

<p-sidebar [(visible)]="visibleListBsk" [baseZIndex]="10000" [style]="{width:'40vw'}">
  @if (visibleListBsk === true) {
    <page-basket-list [accesBsk]="true" [accesShortBsk]="true"></page-basket-list>
  }
</p-sidebar>

@if (displaySearch === true) {
  <filterdocs
    [visible]="displaySearch"
    (onFilter)="onClickSearch($event)"
    (onClose)="closeSearch()"
    >
  </filterdocs>
}

@if (displayFilter === true) {
  <basketfilter
    [filterAuto]="basketService.currentFilterAuto"
    [data]="basketService.listRequest"
    [visible]="displayFilter"
    [editorService]="editorService"
    (onSelectFilter)="onClickFilter($event)"
    (onClose)="onCloseFilter()"
    >
  </basketfilter>
}

@if (index == 1) {
  <displayresult
    #dispresult
    [srchMode]="srchMode"
    [resultDisplay]="resultDisplay"
    [btnAction]="true"
    [nbDoc]="nbDoc"
    [listColumns]="listColumns"
    [infoList]="infoList"
    [currentSelectedBsk]="currentSelectedBsk"
    [listBskVariable]="bskVariableList"
    [basketMoveAll]="basketMoveAll"
    [curPage]=""
    [request]="currentRequest"
    [isDesktop]="isDesktop"
    [autoDocId]="''"
    [fetchParam]="fetchParam"
    [userList]="userList"
    (onReturnResult)="onReturnResult($event)"
    (onAction)="onAction($event)"
    (onNextDocs)="onNextDocs()"
    >
  </displayresult>
}
